import { action } from 'sky-engine/api/index'

import { DELIVERY_GUIDE } from '@/api/apiModules'

/**
 * 获取下载链接
 * @returns
 */
export function getGuideUrl(params) {
  return action(DELIVERY_GUIDE, 'getGuideUrl', params)
}

/**
 * 获取注意事项
 * @returns
 */
export function getDeliveryGuide(params) {
  return action(DELIVERY_GUIDE, 'getDeliveryGuide', params)
}
